import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { LoginHeader } from '../Common/LoginHeader';
import { Footer } from '../Common';
import Profile from '../../Models/Profile';
// import {connect} from 'react-redux';
// import {forgetPassword} from '../../../Action/forgetPassword';

class ForgetPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            email: '',
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        window.localStorage.removeItem('info');
        window.localStorage.removeItem('pro_pic');
        localStorage.clear();
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        e.preventDefault();
        document.getElementById("reset").disabled = true;
        let data = {}
        data = {
            email: this.state.email,
        }
        Profile.passwordResetLink(data).then(res => {
            if (res.data.status == 200) {
                this.props.history.push('/password-reset/reset-email-sent');
            } else if (res.data.status == 404) {
                document.getElementById("wrong_mail").style.display = 'block';
                document.getElementById("something_wrong").style.display = 'none';
                document.getElementById("reset").disabled = false;
            } else {
                document.getElementById("something_wrong").style.display = 'block';
                document.getElementById("wrong_mail").style.display = 'none';
                document.getElementById("reset").disabled = false;
            }
        })
    }

    render() {
        return (
            <div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        {/* <div className="col-md-12"> */}
                        <div className="mt-5">
                            <div className="col-md-12 tr_blank_big"></div>
                            <div className="col-md-12 tr_blank_big"></div>
                            <div className="mobile_width" style={{ minHeight: "520px" }}>
                                <div className="row">
                                    <div className="col-md-3"></div>
                                    <div className="col-md-6 form-group">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="reg_first" style={{ borderBottom: "1px solid #e6e6e6" }}><b>{this.props.t('0')}</b></div>
                                            <div><br /></div>
                                            <div className="" style={{ textAlign: "left" }}>
                                                <span className="weighted_text"><b>{this.props.t('1')}</b></span>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div className="" style={{ textAlign: "left" }}>
                                                <input className="input_box" style={{width:'100%'}} placeholder=" info@domain.com" type="email" value={this.state.email} onChange={this.updateValue.bind(this, 'email')} />
                                                <span id="wrong_mail" className="weighted_text" style={{ color: "red", display: "none", fontSize: "10px" }}><b>{this.props.t('2')}ID{this.props.t('3')}</b></span>
                                                <span id="something_wrong" className="weighted_text" style={{ color: "red", display: "none", fontSize: "10px" }}><b>{this.props.t('4')} {this.props.t('5')}</b></span>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div className="remember_text mobile_button" style={{ textAlign: "center", paddingLeft: "4%" }}>
                                                <button id="reset" type="submit" className="agree_button" onSubmit={this.handleSubmit.bind(this)}>{this.props.t('6')}</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5" >
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = (state) => ({
//     forgetPassword: state.forgetPassword,
// });
// ForgetPassword=connect(mapStateToProps,{forgetPassword})(ForgetPassword);
export { ForgetPassword };

 ForgetPassword = withTranslation('src_Components_ResetPassword_ForgetPassword')(ForgetPassword);